const settings = {
  API_URL: process.env.REACT_APP_API_URL || 'https://dev-crm.wheelsanalytics.com/api/v1/',
  ENV: process.env.REACT_APP_ENV || 'development'
};

export default settings;